import { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { Route, Routes } from 'react-router';

import AppProvider from './AppProvider';
import { logException } from './common/sentry';
import { OuraThemeProvider } from './common/styles/theme';
import LoadingScreen from './components/LoadingScreen';
import ErrorFallback from './components/shared/ErrorBoundary/ErrorFallBack';
import SupportSetup from './components/SupportSetup';
import { LocaleProvider } from './localization/LocaleContext';

const AuthenticatedApp = lazy(() => import('./components/AuthenticatedApp'));

const UnAuthenticatedApp = lazy(
  () => import('./components/UnAuthenticatedApp'),
);

const DeepLinkApp = lazy(
  () => import('./components/unauthenticated/DeepLinkApp'),
);

const rootEl = document.getElementById('root');

if (rootEl) {
  createRoot(rootEl).render(
    <OuraThemeProvider>
      <LocaleProvider>
        <ErrorBoundary FallbackComponent={ErrorFallback} onError={logException}>
          <AppProvider>
            <SupportSetup />
            <Suspense fallback={<LoadingScreen />}>
              <Routes>
                <Route path="/user/*" element={<UnAuthenticatedApp />} />
                <Route path="/app/*" element={<DeepLinkApp />} />
                <Route path="*" element={<AuthenticatedApp />} />
              </Routes>
            </Suspense>
          </AppProvider>
        </ErrorBoundary>
      </LocaleProvider>
    </OuraThemeProvider>,
  );
}
